import React, { useState } from 'react';
import { API_BASE, getToken } from '../services/apiClient';

// Customer-addressed Rate Sheet PDF generator. Opened blank (standalone) or
// pre-filled from a bid's customer. Posts to /rate-sheet/pdf and opens the PDF.
export default function RateSheetModal({ initial, onClose }) {
  const [form, setForm] = useState({
    customer_name: initial?.customer_name || '',
    attn: initial?.attn || '',
    address: initial?.address || '',
    effective: initial?.effective || `${new Date().getFullYear()} calendar year`,
  });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const inp = { width: '100%', boxSizing: 'border-box', border: '1px solid #d1d5db', borderRadius: 8, padding: '10px 12px', fontSize: 14, background: '#fff' };
  const lbl = { fontSize: 11, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: 0.4, display: 'block', marginBottom: 4 };

  async function generate() {
    setBusy(true); setErr('');
    try {
      const res = await fetch(`${API_BASE}/rate-sheet/pdf`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'x-worker-token': getToken() }, body: JSON.stringify(form) });
      if (!res.ok) throw new Error('Could not generate the rate sheet.');
      const url = URL.createObjectURL(await res.blob());
      window.open(url, '_blank');
      setTimeout(() => URL.revokeObjectURL(url), 60000);
      onClose();
    } catch (e) { setErr(e.message || 'Failed to generate.'); }
    setBusy(false);
  }

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 4000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 14, width: 460, maxWidth: '100%', boxShadow: '0 12px 48px rgba(0,0,0,0.2)' }}>
        <div style={{ background: '#1e3a5f', borderRadius: '14px 14px 0 0', padding: '14px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 14, fontWeight: 700, color: '#fff' }}>📄 Rate Sheet for a Customer</span>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#fff', fontSize: 20, cursor: 'pointer' }}>×</button>
        </div>
        <div style={{ padding: 20, display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div style={{ fontSize: 12.5, color: '#6b7280' }}>Fill in who this is for — it prints on Titan letterhead with the current rates. Leave blank for a generic copy.</div>
          <div><label style={lbl}>Customer / Company</label><input value={form.customer_name} onChange={e => set('customer_name', e.target.value)} style={inp} placeholder="Sierra General Contractors" /></div>
          <div><label style={lbl}>Attn (contact)</label><input value={form.attn} onChange={e => set('attn', e.target.value)} style={inp} placeholder="John Sample" /></div>
          <div><label style={lbl}>Address</label><textarea value={form.address} onChange={e => set('address', e.target.value)} rows={2} style={{ ...inp, resize: 'vertical', fontFamily: 'inherit' }} placeholder="1200 Industrial Way, Sparks, NV 89431" /></div>
          <div><label style={lbl}>Effective</label><input value={form.effective} onChange={e => set('effective', e.target.value)} style={inp} /></div>
          {err && <div style={{ color: '#dc2626', fontSize: 13 }}>{err}</div>}
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
            <button onClick={onClose} style={{ padding: '10px 16px', borderRadius: 8, border: '1px solid #e5e7eb', background: '#fff', fontSize: 14, cursor: 'pointer' }}>Cancel</button>
            <button onClick={generate} disabled={busy} style={{ padding: '10px 20px', borderRadius: 8, border: 'none', background: busy ? '#ccc' : '#e87722', color: '#fff', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>{busy ? 'Generating…' : 'Generate PDF →'}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
